import { createApi } from '@reduxjs/toolkit/query/react';
import { client } from '../../api/NestClient';
import { nestBaseQuery } from '../../utils/nestBaseQuery';
import type { paths, components } from '../../api/types/api';

/** Response type for GET /api/v1/users */
type GetUserDataResponse =
  paths['/api/v1/users']['get']['responses']['200']['content']['application/json'];

/** Request body for POST /api/v1/users (update user info) */
type UpdateUserInfoDto = components['schemas']['UpdateUserInfoDto'];


export const profileSettingsApi = createApi({
  reducerPath: 'profileSettingsApi',
  baseQuery: nestBaseQuery,
  tagTypes: ['UserData'],
  endpoints: (builder) => ({
    getUserData: builder.query<GetUserDataResponse, void>({
      query: () => client.GET('/api/v1/users'),
      providesTags: ['UserData'],
    }),
    updateUser: builder.mutation<[], UpdateUserInfoDto>({
      query: (body) => client.POST('/api/v1/users', { body }),
      invalidatesTags: ['UserData'],
    }),
  }),
});

export const {
  useGetUserDataQuery,
  useLazyGetUserDataQuery,
  useUpdateUserMutation,
} = profileSettingsApi;
